import { render, staticRenderFns } from "./EditDocumentModal.vue?vue&type=template&id=1180cf6f&scoped=true"
import script from "./EditDocumentModal.vue?vue&type=script&lang=js"
export * from "./EditDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./EditDocumentModal.vue?vue&type=style&index=0&id=1180cf6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180cf6f",
  null
  
)

export default component.exports